import { useState } from "react";
import { useApp } from "../context/AppContext";
import GrowthPointsView from "./GrowthPointsView";
import CannibalizationView from "./CannibalizationView";

const TABS = [
  { key: "growth", label: "Точки росту", icon: "📈" },
  { key: "cannibal", label: "Канібалізація", icon: "❌" },
];

export default function GscAnalysisView() {
  const { dark, t, stitle, muted } = useApp();
  const [tab, setTab] = useState("growth");

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <h2 style={{ ...stitle, margin: 0 }}>Аналіз GSC</h2>
          <p style={{ ...muted, margin: "4px 0 0", fontSize: 13 }}>Точки росту та виявлення канібалізації</p>
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {TABS.map(tb => (
          <button key={tb.key} onClick={() => setTab(tb.key)} style={{
            padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer",
            background: tab === tb.key ? "#6366f1" : dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
            color: tab === tb.key ? "#fff" : t.text,
            fontWeight: tab === tb.key ? 700 : 500, fontSize: 13, fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 6, transition: "all .15s",
          }}>
            <span>{tb.icon}</span> {tb.label}
          </button>
        ))}
      </div>
      {tab === "growth" && <GrowthPointsView />}
      {tab === "cannibal" && <CannibalizationView />}
    </div>
  );
}
